export const PROJECT_CODE = 'EDOC'
